import { Badge, Box, Collapse, Flex, HStack, Text, useDisclosure, VStack } from "@chakra-ui/react"
import { ChevronDownIcon, ChevronUpIcon } from "lucide-react"
import { ResultRow } from "./ResultRow"
import { ResultListDto } from "../../../../Api/client/ResultClient"
import React from "react";

function ResultList({
  list,
  listIndex,
  rowRefs
}: {
  list: ResultListDto
  listIndex: number
  rowRefs: any
}) {
  const { isOpen, onToggle } = useDisclosure()

  return isOpen ? (
    <Box borderWidth="1px" borderRadius="md">
      <Flex
        p={3}
        cursor="pointer"
        align="center"
        justify="space-between"
        onClick={onToggle}
      >
        <Text fontWeight="bold">{list.name}</Text>

        <HStack>
          <Badge>{list.results.length}</Badge>
          <ChevronUpIcon />
        </HStack>
      </Flex>

      <Collapse in={isOpen}>
        <VStack align="stretch" spacing={0}>
          {list.results.map((r, ri) => (
            <ResultRow
              key={ri}
              showResults={list.showResults}
              result={r}
              position={ri + 1}
              rowKey={`${listIndex}-${ri}`}
              rowRefs={rowRefs}
            />
          ))}
        </VStack>
      </Collapse>
    </Box>
  ) : (
    <Box borderWidth="1px" borderRadius="md">
      <Flex
        p={3}
        cursor="pointer"
        align="center"
        justify="space-between"
        onClick={onToggle}
      >
        <Text fontWeight="bold">{list.name}</Text>

        <HStack>
          <Badge>{list.results.length}</Badge>
          <ChevronDownIcon />
        </HStack>
      </Flex>
    </Box>
  );
}

export default React.memo(ResultList);
